import React from 'react'
import { CampaignButton } from './CampaignButton'
import TryAgentsBackground from '../../assets/campaign/TryAgentsBackground.png'
import { IconStartTrialCampaign } from '../icons'
import { Link } from '~/components/common/Link'

interface AgentButtonProps {
  children: React.ReactNode
}

interface HorizontalScrollProps {
  children: React.ReactNode
  className?: string
  direction?: 'normal' | 'reverse'
}

const AGENTS_ROW_1 = [
  'Integration Generator',
  'Dataweave Generator',
  'Coding Agent',
  'MUnit Test Generator',
  'Sample Data Generator',
  'Document Generator',
  'Diagram Generator'
]

const AGENTS_ROW_2 = [
  'Domain Diagram Generator',
  'Mapping Table Generator',
  'Single Repo Code Lens',
  'Multi Repo Code Lens',
  'Code Review Lens',
  'Migration Generator',
  'MuleSoft to Node.js'
]

const AgentButton: React.FC<AgentButtonProps> = ({ children }) => (
  <button className='bg-white px-4 py-3 rounded-lg font-medium whitespace-nowrap transition-all duration-200 hover:shadow-md mx-2 ring-1 ring-gray-200'>
    <span className='bg-gradient-to-r from-[#8063FA] to-[#C8A7FF] text-transparent bg-clip-text'>
      {children}
    </span>
  </button>
)

const HorizontalScroll: React.FC<HorizontalScrollProps> = ({
  children,
  direction = 'normal',
  className = ''
}) => {
  return (
    <div className='relative w-full h-fit p-2 overflow-hidden'>
      <div
        className={`inline-flex ${className}`}
        style={{
          whiteSpace: 'nowrap',
          animation: `scroll 20s linear infinite ${direction}`
        }}
      >
        <div className='flex'>{children}</div>
        <div className='flex'>{children}</div>
        <div className='flex'>{children}</div>
      </div>
      <style>{`
        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-33.33%);
          }
        }
      `}</style>
    </div>
  )
}

const TryAgentsSection: React.FC = () => {
  return (
    <div className='w-full min-h-screen relative overflow-hidden rounded-lg'>
      <div className='absolute inset-0'>
        <img
          src={TryAgentsBackground}
          className='w-screen h-screen object-cover object-center blur-[2px]'
          alt='Background'
        />
      </div>

      <div className='w-5/6 mx-auto mt-20 pt-20 pb-10 text-center relative backdrop-blur-lg bg-[#DEDBEC]/20 backdrop-blur-3xl rounded-3xl'>
        <h1 className='text-8xl font-normal tracking-tight mb-4'>
          Try all{' '}
          <span className='bg-gradient-to-r from-[#8063FA] to-[#C8A7FF] text-transparent bg-clip-text font-medium'>
            10+
          </span>{' '}
          Curie
          <br />
          Agents for{' '}
          <span className='bg-gradient-to-r from-[#8063FA] to-[#C8A7FF] text-transparent bg-clip-text font-medium'>
            Free
          </span>
        </h1>

        <CampaignButton
          className='px-4 py-6 my-10 rounded-full disabled:opacity-60'
          onClick={() => window.open('https://platform.curietech.ai/signup', '_blank')}
        >
          <div className='flex flex-row gap-2 items-center'>
            <span className='text-xl font-normal'>Sign Up for Free</span>
            <IconStartTrialCampaign />
          </div>
        </CampaignButton>

        <div className='relative space-y-4'>
          <HorizontalScroll>
            {AGENTS_ROW_1.map(agent => (
              <AgentButton key={agent}>{agent}</AgentButton>
            ))}
          </HorizontalScroll>

          <HorizontalScroll direction='reverse'>
            {AGENTS_ROW_2.map(agent => (
              <AgentButton key={agent}>{agent}</AgentButton>
            ))}
          </HorizontalScroll>
        </div>
      </div>
    </div>
  )
}

export default TryAgentsSection
